export const scales = {
  LG: "lg",
  IMD: "imd",
  MD: "md",
  SM: "sm",
};

export const variants = {
  PRIMARY: "primary",
  OUTLINED: "outlined",
  BUY: "buy",
  SELL: "sell",
};
